import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Alert from 'react-bootstrap/Alert'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import {Button} from '@material-ui/core';
import {Link} from 'react-router-dom';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';

import ApiUtils from '../util/ApiUtils';
import UINotes from '../util/UINotes';
import "./Rewards.css";
import Utilities from "../util/Utilities";
import SPUtilities from "../util/SPUtilities";
import SPCalc from "../util/SPCalc";
import FilterRewards from "./FilterRewards";
import Views from "./Views";

class CurrentRewards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      size: 10,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    let totalStake = SPCalc.getTotal(this.props.rewards, "stake", true);
    let totalRewards = SPCalc.getTotal(this.props.rewards, "reward", true);

    var columns;
    if (window.innerWidth < 600) {
      columns = [
        {text: "Address",dataField: "address", formatter: SPUtilities.addressReallyShortFormatterVisibleLink, sort: true, headerStyle: Utilities.width(20)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(22)},
        {text: "Stake",dataField: "stake", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(21)},
        {text: "Rewards",dataField: "reward", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        {text: "Pending",dataField: "rewardsBalance", formatter: SPCalc.calcPendingRewards, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
      ];
    } else if (window.innerWidth < 1000) {
      columns = [
        {text: "Address",dataField: "address", formatter: SPUtilities.addressShortFormatterVisibleLink, sort: true, headerStyle: Utilities.width(20)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(25)},
        {text: "Stake in Pool",dataField: "stake", formatter: SPUtilities.coinCountCellFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        {text: "Rewards in Pool",dataField: "reward", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        {text: "Estimated Pending Rewards",dataField: "rewardsBalance", formatter: SPCalc.calcPendingRewards, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      ];
    } else {
      columns = [
        {text: "Address",dataField: "address", formatter: SPUtilities.addressShortFormatterVisibleLink, sort: true, headerStyle: Utilities.width(15)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(20)},
        {text: "Pool Total Stake", dataField: "totalStake", formatter: SPUtilities.coinCountCellFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        {text: "Stake in Pool",dataField: "stake", formatter: SPUtilities.coinCountCellFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "% Stake (portfolio)",dataField: "stake", formatter: SPCalc.calcWeight, formatExtraData: totalStake, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        {text: "Rewards in Pool",dataField: "reward", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "% Rewards (portfolio)",dataField: "reward", formatter: SPCalc.calcWeight, formatExtraData: totalRewards, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        {text: "Estimated Pending Rewards",dataField: "rewardsBalance", formatter: SPCalc.calcPendingRewards, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      ];
    }

    return (<div>
      <BootstrapTable keyField='poolName' data={ this.props.rewards }
        columns={ columns } striped expandableRow={ () => { return true; } }
        hover condensed noDataIndication="No results"/>
      </div>);
  }

}

export default CurrentRewards;



// WEBPACK FOOTER //
// ./src/address/CurrentRewards.js